import { render } from "./IconPhotoCamera.vue?vue&type=template&id=53a226eb"
import script from "./IconPhotoCamera.vue?vue&type=script&lang=js"
export * from "./IconPhotoCamera.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__